var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", _vm._b({}, "Card", _vm.options, false), [
    _c("div", { staticClass: "card__container" }, [
      _c(
        "div",
        { staticClass: "profil__picture__section" },
        [
          _c("div", { staticClass: "avatar" }, [
            _c("span", [
              _vm.profilePicture
                ? _c("img", {
                    attrs: { src: _vm.profilePicture, alt: "", srcset: "" }
                  })
                : _c("img", {
                    attrs: {
                      src:
                        "https://www.nicepng.com/png/detail/136-1366211_group-of-10-guys-login-user-icon-png.png",
                      alt: "",
                      srcset: ""
                    }
                  })
            ])
          ]),
          _vm._v(" "),
          _c(
            "file-uploader",
            {
              on: { input: _vm.uploadPicture },
              model: {
                value: _vm.uploadedPicture,
                callback: function($$v) {
                  _vm.uploadedPicture = $$v
                },
                expression: "uploadedPicture"
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "activator" }, slot: "activator" },
                [
                  _c(
                    "Button",
                    _vm._b({}, "Button", _vm.data.picture.button, false)
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "profile__info__section" }, [
        _c("div", { staticClass: "profile__header" }, [
          _c("span", [_vm._v(_vm._s(_vm.data.profile.title))])
        ]),
        _vm._v(" "),
        _c("form", { staticClass: "profile__form" }, [
          _c("div", { staticClass: "section__1" }, [
            _c("span", { staticClass: "section_title" }, [
              _vm._v(_vm._s(_vm.data.profile.section_1.title))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__group" },
              _vm._l(_vm.data.profile.section_1.elements, function(
                item,
                index
              ) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "field__container",
                    style: "width:" + item.width
                  },
                  [
                    _c(
                      item.component,
                      _vm._b(
                        {
                          tag: "components",
                          attrs: {
                            value: _vm.user[item.name],
                            selected: item.options
                              ? item.options.find(function(count) {
                                  return count.name == _vm.user[item.name]
                                })
                              : true,
                            checked: _vm.user[item.text],
                            disabled: item.disabled
                          },
                          on: {
                            input: function($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.getValue.apply(
                                void 0,
                                [item.name, item].concat(argsArray)
                              )
                            }
                          }
                        },
                        "components",
                        Object.assign(item, { width: null }),
                        false
                      )
                    ),
                    _vm._v(" "),
                    item.name == "email"
                      ? _c(
                          "span",
                          { staticClass: "largeW" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "edit_emaill",
                                attrs: { to: "/user-email" }
                              },
                              [
                                _c("i", { staticClass: "fa fa-edit" }),
                                _vm._v("  Edit email")
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section__2" }, [
            _c("span", { staticClass: "section_title" }, [
              _vm._v(_vm._s(_vm.data.profile.section_2.title_1))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form__group" },
              _vm._l(_vm.data.profile.section_2.elements, function(
                item,
                index
              ) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "field__container",
                    style: "width:" + item.width
                  },
                  [
                    _c(
                      item.component,
                      _vm._b(
                        {
                          tag: "components",
                          attrs: { value: _vm.user[item.name] },
                          on: {
                            input: function($event) {
                              var i = arguments.length,
                                argsArray = Array(i)
                              while (i--) argsArray[i] = arguments[i]
                              return _vm.getValue.apply(
                                void 0,
                                [item.name, item].concat(argsArray)
                              )
                            }
                          }
                        },
                        "components",
                        Object.assign(item, {
                          width: item.component == "Input" ? null : item.width
                        }),
                        false
                      )
                    )
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("span", { staticClass: "section_title" }, [
              _vm._v(_vm._s(_vm.data.profile.section_2.title_2))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "skills__tags form__group" },
              _vm._l(_vm.data.profile.section_2.software_skills, function(
                tag,
                tagInedx
              ) {
                return _c("div", { key: tagInedx, staticClass: "skill_tag" }, [
                  _c("input", {
                    attrs: {
                      type: "checkbox",
                      hidden: "",
                      name: "tags",
                      id: tag
                    },
                    domProps: {
                      checked: _vm.user["SoftwareSkills"].includes(tag)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      attrs: { for: tag },
                      on: {
                        click: function($event) {
                          return _vm.addTag(tag)
                        }
                      }
                    },
                    [_vm._v(_vm._s(tag))]
                  )
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit-btn" },
              [
                _c(
                  "Button",
                  _vm._b(
                    { on: { click: _vm.updateUser } },
                    "Button",
                    _vm.data.profile.section_2.update_btn,
                    false
                  )
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6452ae60", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6452ae60","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user_profile/info/ownerInfo.vue
// module id = null
// module chunks = 